import type { CSSProperties } from 'react';

import { TIP_JAR_THEME_VARIABLES, WEB_THEME_FONT_STACK } from '@shared/dream-components';

import type { TipJarTheme } from '~/interfaces/tip_jar';

/**
 * The `--wt-*` variables for what the writer changed on the page, in the root styles' formats. They go on an element
 * around the page rather than `:root`, so the navbar and footer keep the site's theme.
 */
export const toTipJarThemeStyle = (theme: TipJarTheme = {}): CSSProperties => {
  const variables: Record<string, string> = {};

  for (const [variable, { webThemeKey }] of Object.entries(TIP_JAR_THEME_VARIABLES)) {
    const value = theme[webThemeKey];
    if (!value) continue;

    variables[variable] = webThemeKey.endsWith('_font') ? `"${value}", ${WEB_THEME_FONT_STACK}` : value;
  }

  return variables as CSSProperties;
};

export const getTipJarThemeFontFamilies = (theme: TipJarTheme = {}) => [
  ...new Set(
    [theme.header_font, theme.body_font, theme.button_font].filter((family): family is string => Boolean(family)),
  ),
];
